import { Component, useEffect, useState } from "react";
import Api, { exceptionNotificationAPI } from "./api";
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../hooks/auth';
import { success_message, info_message, error_message } from '../components/Toast/index';
import { func } from "prop-types";
import GetTypeInput from "../components/FormInput/set";
import { regex } from "uuidv4";
import moment from "moment";
import { getAnswers, setText } from "./functions";


export const validatePPM = ({
    moduleObject,
    setModuleObject,
    row,
    ssk,
    refNumber,         // ex: key da temperatura
    newAnswers,
    subSectionKPIs,
    oldTextValue
}) => {

    const answersList = newAnswers.filter(
        a => a.subSectionID === ssk.subSectionID && a.row === row
    );

    const columnToValidate = moduleObject.columnRows.filter(
        cr =>
            cr.subSectionID === ssk.subSectionID &&
            cr.parentColumnRowID != null &&
            cr.keyword === "FUMIGATION"
    );

    const tempAns = newAnswers.find(a => a.refNumber == 20203);
    if (tempAns != null || tempAns?.numberValue > 0) {
        const temp = parseFloat(tempAns.numberValue);

        // 4) filtra regras segundo a temperatura
        const reqs = moduleObject.standardRequirementsList.filter(x => (temp >= parseFloat(x.startTemperature) && temp <= parseFloat(x.finalTemperature))
            || (temp >= parseFloat(x.startTemperature) && x.finalTemperature == 0));

        if (reqs.length === 0) {
            return [moduleObject, newAnswers];
        }

        // 5) itera sobre cada req e valida a sequência com MinimumExposureTime dinâmico
        for (const req of reqs) {
            const threshold = parseFloat(req.ppmPhosphineConcentration);

            // **Aqui** pegamos o número de dias que precisamos de sequência
            const requiredDays = parseInt(req.minimumExposureTime, 10);

            // mapeia subSectionKPIID → order
            const kpiOrderMap = {};
            columnToValidate.forEach(cr => {
                const kpi = subSectionKPIs.find(s => s.columnRowID === cr.columnRowID);
                if (kpi) {
                    kpiOrderMap[kpi.subSectionKPIID] = cr.columnRowOrder;
                }
            });

            // ordena as entries pelo order
            const sortedKpiEntries = Object.entries(kpiOrderMap)
                .sort(([, oA], [, oB]) => oA - oB);

            // monta mapa subSectionKPIID → índice no sorted array
            const kpiIndexMap = sortedKpiEntries.reduce((m, [kpiId], idx) => {
                m[kpiId] = idx;
                return m;
            }, {});

            // filtra e ordena as respostas
            const orderedAnswers = answersList
                .filter(ans => kpiIndexMap[ans.subSectionKPIID] !== undefined)
                .sort(
                    (a, b) =>
                        kpiIndexMap[a.subSectionKPIID] -
                        kpiIndexMap[b.subSectionKPIID]
                );

            // sliding window de tamanho requiredDays
            let validSequence = null;
            for (let start = 0; start <= orderedAnswers.length - (requiredDays + 1); start++) {
                const window = orderedAnswers.slice(start, start + (requiredDays + 1));
                const allOk = window.every(w => parseFloat(w.numberValue) >= threshold);
                if (allOk) {
                    validSequence = window;
                    break;
                }
            }

            if (validSequence) {
                // remove action plan
                const [{ moduleObject: updatedModule, newAnswers: updatedAns }] = removeActionPlanLine({
                    sskpi: ssk,
                    newAnswers,
                    moduleObject,
                    subSectionKPIs,
                    setModuleObject,
                    referenceRow: row
                });
                return [updatedModule, updatedAns];
            }

            // se não encontrou, cria action plan e continua
            newAnswers = createActionPlan({
                sskpi: ssk,
                newAnswers,
                moduleObject,
                subSectionKPIs,
                setModuleObject,
                referenceRow: row
            });
        }
    }

    // fim do loop: retorna estado final
    return [moduleObject, newAnswers];
};


export const createActionPlan = ({ sskpi, newAnswers, referenceRow, moduleObject, subSectionKPIs, setModuleObject, oldTextValue }) => {
    var subSectionActionPlan = null;
    var newModuleObject = null;
    if (sskpi != null && referenceRow != null) {
        var sectionActionPlan = moduleObject.data.sections.filter((item) => {
            var subSectionFiltered = item.subSections.filter(e => e.isActionPlan)
            if (subSectionFiltered && subSectionFiltered.length > 0) {
                return true
            } else {
                return false
            }
        })
        if (sectionActionPlan && sectionActionPlan.length > 0) {
            var subSectionActionPlan = sectionActionPlan[0].subSections.find(e => e.isActionPlan)
            if (subSectionActionPlan && sskpi.subSectionID != subSectionActionPlan.subSectionID) {
                var sskContainerDesc = subSectionKPIs.find(x => x.isActionPlanReference);
                if (sskContainerDesc != null) {
                    var answer = newAnswers.find(x => x.subSectionKPIID == sskContainerDesc.subSectionKPIID && x.row == referenceRow);
                    if (answer != null && answer.textValue != "") {
                        newAnswers = addNewLine(subSectionActionPlan, false, answer.textValue, subSectionActionPlan.isActionPlanBy, moduleObject, setModuleObject, subSectionKPIs, referenceRow, newAnswers);
                    }
                }
            }
        }
    }
    return newAnswers;

}

const addNewLine = (ss, boolSet = false, value = null, isActionPlanBy = 2, moduleObject, setModuleObject, subSectionKPIs, referenceRow, newAnswers) => {
    if (ss.isActionPlan) {
        var columnRowKey = ss.columnRows.find(e => e.name.includes("Key") || e.name.includes("Section"))
        if (columnRowKey) {
            var sskpi = subSectionKPIs.find(e => e.columnRowID == columnRowKey.columnRowID);
            var valueToCompare = value;

            var myAnswer = getActionPlanAnswers(
                {
                    'newAnswers': newAnswers,
                    'ref': sskpi.refNumber,
                    'subSectionKPI': sskpi,
                    'referenceRow': referenceRow,
                })[0];

            if (myAnswer == null) {
                var newNumber = ss.numberOfRows

                var myAnswers = newAnswers.filter(x => x.subSectionKPIID == sskpi.subSectionKPIID);

                if ((myAnswer == null && myAnswers.length > 0) || myAnswers.length == 0) {
                    newNumber = newNumber == 0 ? 1 : newNumber + 1;
                }

                moduleObject.data.sections.map((section) => {
                    var currentSubSection = section.subSections.find(x => x.subSectionID == ss.subSectionID);
                    if (currentSubSection != null) {
                        currentSubSection.numberOfRows = newNumber;
                    }
                });
            }

            var objNewAnswers = setText({
                'subSectionKPI': sskpi,
                'ref': sskpi.refNumber,
                'value': valueToCompare,
                'row': myAnswer != null ? myAnswer.row : newNumber - 1,
                'moduleObject': moduleObject,
                'setModuleObject': setModuleObject,
                'subSectionKPIs': subSectionKPIs,
                'isActionPlan': true,
                'referenceRow': referenceRow,
                'newAnswersList': newAnswers
            })
            return objNewAnswers.answers;
        }
    }
    return newAnswers;
}

export const getActionPlanAnswers = ({ newAnswers, ref, subSectionKPI, row, referenceRow }) => {
    var myAnswer;
    var filter = {
        'subSectionKPIID': subSectionKPI?.subSectionKPIID,
        'refNumber': ref,
        'referenceRow': referenceRow,
        'row': row,
    }

    myAnswer = newAnswers.filter(function (item) {

        for (var key in filter) {
            if (filter[key] == null)
                continue;
            else if (item[key] == null || item[key] != filter[key])
                return false;
        }
        return true;
    });

    return myAnswer;
};

const removeActionPlanLine = ({ sskpi, moduleObject, row, setModuleObject, subSectionKPIs, referenceRow, newAnswers }) => {
    var subSectionActionPlan = null;
    var newModuleObject = null;
    if (sskpi != null && referenceRow != null) {
        var sectionActionPlan = moduleObject.data.sections.filter((item) => {
            var subSectionFiltered = item.subSections.filter(e => e.isActionPlan)
            if (subSectionFiltered && subSectionFiltered.length > 0) {
                return true
            } else {
                return false
            }
        })
        if (sectionActionPlan && sectionActionPlan.length > 0) {
            var subSectionActionPlan = sectionActionPlan[0].subSections.find(e => e.isActionPlan)
            if (subSectionActionPlan && sskpi.subSectionID != subSectionActionPlan.subSectionID) {
                var sskContainerDesc = subSectionKPIs.find(x => x.isActionPlanReference);
                if (sskContainerDesc != null) {
                    var columnRowKey = subSectionActionPlan.columnRows.find(e => e.name.includes("Key") || e.name.includes("Section"))
                    if (columnRowKey) {
                        var ssk = subSectionKPIs.find(e => e.columnRowID == columnRowKey.columnRowID);
                        if (ssk != null) {
                            var answersToRemove = newAnswers.filter(x => x.subSectionID == subSectionActionPlan.subSectionID && x.referenceRow == referenceRow);
                            var answersToKeep = newAnswers.filter(x => x.subSectionID != subSectionActionPlan.subSectionID || (x.subSectionID == subSectionActionPlan.subSectionID && x.row != row && x.referenceRow != referenceRow));
                            var newNumber = subSectionActionPlan.numberOfRows - 1;


                            moduleObject.data.sections.map((section) => {
                                var currentSubSection = section.subSections.find(x => x.subSectionID == subSectionActionPlan.subSectionID);
                                if (currentSubSection != null) {
                                    currentSubSection.numberOfRows = newNumber;
                                }
                            });

                            moduleObject.removedAnswers = answersToRemove;

                            var newModuleObject = { ...moduleObject, answers: answersToKeep }

                            answersToKeep.map((item) => {
                                if (item.row > row && item.subSectionID == subSectionActionPlan.subSectionID) {
                                    return item.row = item.row - 1;
                                }
                            });

                            newModuleObject.data.sections.map((section) => {
                                var currentSubSection = section.subSections.find(x => x.subSectionID == subSectionActionPlan.subSectionID);
                                if (currentSubSection != null) {
                                    currentSubSection.numberOfRows = newNumber;
                                }
                            });

                            return [{ moduleObject: newModuleObject, newAnswers: answersToKeep }];
                        }
                    }
                }
            }
        }
    }

    return [{ moduleObject: moduleObject, newAnswers: newAnswers }];
}